import { IPatientMedicalNoteModel } from "@/Patient/Models/UI/MedicalNote/IPatientMedicalNoteModel";

class MedicalNoteSections {
    constructor(noteModel: IPatientMedicalNoteModel) {
        this.isAssesmentSectionExpanded = noteModel.get("IsAssesmentSectionExpanded");
        this.isFormsSectionExpanded = noteModel.get("IsFormsSectionExpanded");
        this.isMedicalSummarySectionExpanded = noteModel.get("IsMedicalSummarySectionExpanded");
        this.isPlanSectionExpanded = noteModel.get("IsPlanSectionExpanded");
        this.isProgressNoteSectionExpanded = noteModel.get("IsProgressNoteSectionExpanded");
    }

    public isAssesmentSectionExpanded: boolean;
    public isFormsSectionExpanded: boolean;
    public isMedicalSummarySectionExpanded: boolean;
    public isPlanSectionExpanded: boolean;
    public isProgressNoteSectionExpanded: boolean;
}

export { MedicalNoteSections };
